"use client";

import Link from "next/link";
import { FooterControls } from "./FooterControls";
import { useTranslation } from "@/lib/i18n/context";
import { openCookiePreferences } from "@/components/consent/CookieConsent";
import { DoNotSellLink } from "@/components/consent/DoNotSellLink";

export function Footer() {
  const { t } = useTranslation();
  const fn = t.landing.cover.footerNav;
  const cols = [fn.product, fn.company, fn.resources];
  const legal = fn.legal;

  return (
    <footer className="relative z-[2] px-5 md:px-12 py-20 pb-10 mt-0" style={{ background: "#2A2620", color: "#F2EEE8" }}>
      <div className="max-w-[1320px] mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 pb-12 border-b border-[#4A4641]">
          {cols.map((c) => (
            <div key={c.heading}>
              <h3 className="font-mono text-[11px] tracking-[0.18em] uppercase mb-4 font-medium">{c.heading}</h3>
              <ul className="list-none p-0 m-0">
                {c.links.map((l) => (
                  <li key={l.label} className="mb-2.5 leading-[1.9]">
                    <Link href={l.href} className="text-[#C9C4BD] text-sm hover:text-[var(--terracotta)] transition">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div>
            <h3 className="font-mono text-[11px] tracking-[0.18em] uppercase mb-4 font-medium">{legal.heading}</h3>
            <ul className="list-none p-0 m-0">
              {legal.links.map((l) => (
                <li key={l.label} className="mb-2.5">
                  <Link href={l.href} className="text-[#C9C4BD] text-sm hover:text-[var(--terracotta)] transition">
                    {l.label}
                  </Link>
                </li>
              ))}
              <li className="mb-2.5">
                <button type="button" onClick={() => openCookiePreferences()} className="text-[#C9C4BD] text-sm hover:text-[var(--terracotta)] transition text-left">
                  {t.consent.footer.preferences}
                </button>
              </li>
              <li className="mb-2.5">
                <DoNotSellLink className="text-[#C9C4BD] text-sm hover:text-[var(--terracotta)] transition text-left" />
              </li>
            </ul>
          </div>
        </div>
        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-5 pt-7 pb-1.5">
          <div className="flex items-center gap-2.5 font-display text-[20px] font-medium tracking-[-0.02em] text-[#F2EEE8]">
            <span className="relative w-5 h-5 rounded-full border-[1.5px] border-[#F2EEE8]">
              <span className="absolute inset-1 rounded-full bg-[var(--terracotta)]" />
            </span>
            <span>Journail</span>
          </div>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-3">
            <FooterControls />
            <div className="font-mono text-[11px] tracking-[0.12em] text-[#C9C4BD]">
              © {new Date().getFullYear()} {t.landing.footer.copyright}
            </div>
          </div>
        </div>
        <div className="font-mono text-[11px] tracking-[0.2em] text-[#8A867E] text-center pt-5 border-t border-[#3A3630] mt-6">
          {fn.folio}
        </div>
      </div>
    </footer>
  );
}
